'use client';

import {CaptchaContextProvider} from '@shared/Captcha/Client/CaptchaContext';
import {PropsWithChildren} from 'react';

import {useOmicron} from '@dev-landing/components/OmicronClientContext';

import {logTmrEvent} from '@dev-landing/analytics/analytics';

type Props = {
  yandexSiteKey: string;
  allowBypassCaptcha: boolean;
};

export const CaptchaLayout = ({
  yandexSiteKey,
  allowBypassCaptcha,
  children,
}: PropsWithChildren<Props>) => {
  // требуется результат клиентского запроса для частичной раскатки
  const omicron = useOmicron();
  return (
    <CaptchaContextProvider
      provider={omicron?.config?.CAPTCHA_PROVIDER || 'yandex'}
      showCaptchaAfterSubmit={!!omicron?.config?.SHOW_CAPTCHA_AFTER_SUBMIT}
      yandexSiteKey={yandexSiteKey}
      allowBypassCaptcha={allowBypassCaptcha}
      vkInitEndpoint="/developer/api/vk-captcha-init"
      disabled={!omicron}
      logAnalyticsEvent={logTmrEvent}
    >
      {children}
    </CaptchaContextProvider>
  );
};
